<template>
  <b-card class="offer-card">
    <b-row>
      <b-col cols="3">Offer Name:</b-col>
      <b-col>{{offer.copay_offer_name}}</b-col>
      <b-col class="offer-edit" cols="4">
        <div class="pull-right">
          <a v-if="!isReadonly" v-on:click="$emit('remove', offer)">
            <i class="fa fa-minus-circle"></i>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">Manufacturer:</b-col>
      <b-col>{{offer.manufacture_name}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="3">Drug Name:</b-col>
      <b-col>{{offer.drug_name}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="3">Offer Status:</b-col>
      <b-col>{{getEffectiveStatus(offer) | snakeToTitleCase}}</b-col>
    </b-row>
  </b-card>
</template>
<script>
  export default {
    name: "VBrandLimitOfferListItem",
    props: {
      offer: {
        required: true,
        type: Object
      },
      isReadonly: {
        required: true,
        type: Boolean
      }
    },
    methods: {
      getEffectiveStatus(item) {
        const now = new Date().toISOString();
        if (
          item.current_offer_effective_date &&
          now < item.current_offer_effective_date
        ) {
          return `inactive until ${new Date(
            item.current_offer_effective_date
          ).toLocaleDateString()}`;
        } else if (
          item.current_offer_end_date &&
          item.current_offer_end_date < now
        ) {
          return "inactive";
        } else if (
          item.current_status === "active" &&
          item.current_offer_end_date &&
          item.current_offer_end_date > now &&
          item.current_offer_end_date.indexOf('2099-01-01') === -1
        ) {
          return `active until ${new Date(
            item.current_offer_end_date
          ).toLocaleDateString()}`;
        }
        return item.current_status;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/VBrandLimitOfferListItem.vue